// Client-side exports for the Planning list and the DMUT table.
//
// Unlike the Reports module (where the server renders the file), Planning export
// is "terhadap data yang sedang di tampilkan" — the exact rows currently on
// screen — so we build the workbook in the browser from those rows using the
// already-installed `xlsx` package.

import * as XLSX from 'xlsx';
import { formatDateTime } from './formatters';

const triggerDownload = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// Map a Planning record to the flat row shown in the list, so Excel/CSV match
// exactly what the user sees.
const toListRow = r => ({
  'Id Procurement': r.procId,
  Title: r.title,
  'Procurement Type': r.procurementType,
  'Procurement Method': r.procurementMethod,
  Description: r.description,
  'Created Date': formatDateTime(r.createdDate),
  'Updated Date': formatDateTime(r.updatedDate),
  'Main Status': r.mainStatus,
  'Status Planning': r.status,
});

const timestamp = () => {
  const d = new Date();
  const p = n => String(n).padStart(2, '0');
  return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}_${p(
    d.getHours()
  )}${p(d.getMinutes())}`;
};

export const exportPlanningExcel = rows => {
  const ws = XLSX.utils.json_to_sheet(rows.map(toListRow));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Planning');
  const out = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  triggerDownload(
    new Blob([out], { type: 'application/octet-stream' }),
    `planning_${timestamp()}.xlsx`
  );
};

export const exportPlanningCsv = rows => {
  const ws = XLSX.utils.json_to_sheet(rows.map(toListRow));
  const csv = XLSX.utils.sheet_to_csv(ws);
  // Prepend a BOM so Excel opens UTF-8 CSVs with correct encoding.
  triggerDownload(
    new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' }),
    `planning_${timestamp()}.csv`
  );
};

// Download the DMUT table (the rows shown in the DMUT Invitation tab) as Excel.
export const exportDmutExcel = (rows, procId) => {
  const data = rows.map(r => ({
    'DMUT Name': r.name,
    'PIC Name': r.picName,
    'PIC Email': r.picEmail,
    Invited: r.invited ? 'Yes' : 'No',
  }));
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'DMUT');
  const out = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  triggerDownload(
    new Blob([out], { type: 'application/octet-stream' }),
    `dmut_${procId || 'list'}.xlsx`
  );
};
